import Vue from "vue";
import get from "lodash/get";
import { Event as TableEvent } from "vue-tables-2";

/* eslint-disable no-shadow, no-param-reassign, no-empty-pattern */
const state = {
  initialised: false,
  tableRef: null,
  selectedAppointment: null,

  selectFilters: {
    type: {
      value: "",
      options: [
        {
          label: "Employee",
          value: "Employee",
        },
        {
          label: "Contractor",
          value: "Contractor",
        },
        {
          label: "Franchisee",
          value: "Franchisee",
        },
      ],
    },
    brand: {
      value: "",
      options: [],
    },
    state: {
      value: "",
      options: [
        {
          label: "ACT",
          value: "ACT",
        },
        {
          label: "NSW",
          value: "NSW",
        },
        {
          label: "NT",
          value: "NT",
        },
        {
          label: "QLD",
          value: "QLD",
        },
        {
          label: "SA",
          value: "SA",
        },
        {
          label: "TAS",
          value: "TAS",
        },
        {
          label: "VIC",
          value: "VIC",
        },
        {
          label: "WA",
          value: "WA",
        },
      ],
    },
  },
  selectFilterValues: {},

  shouldFilter: false,
  currentFilters: {
    brand_id: null,
    postcode: null,
    service_types: [],
  },
  hiddenFilters: {
    brand_id: null,
    postcode: null,
    service_types: [],
  },
  lockFilters: false,

  drawnAppointmentIds: [],
  drawnUnavailabilityIds: [],

  currentDate: null,
};

const getters = {
  appointmentAlreadyDrawn: (state) => (appointmentId) =>
    state.drawnAppointmentIds.includes(appointmentId),

  unavailabilityAlreadyDrawn: (state) => (unavailabilityId) =>
    state.drawnUnavailabilityIds.includes(unavailabilityId),

  getSelectFilterValueByName: (state) => (name) => {
    if (state.selectFilterValues[name] !== undefined) {
      return state.selectFilterValues[name];
    }

    return "";
  },

  getSelectFilterValues: (state) => () => state.selectFilterValues,
};

const mutations = {
  selectFiltersChanged(state, change) {
    if (
      change.name &&
      state.selectFilters[change.name] &&
      state.selectFilters[change.name].value !== change.value
    ) {
      state.selectFilters[change.name].value = change.value;

      // Store the new key/value pair in persisted state of tech-availability.selectFilterValues
      state.selectFilterValues[change.name] = change.value;
    }
  },

  resetSelectedAppointment(state) {
    state.selectedAppointment = null;
  },

  setTableReference(state, tableReference) {
    state.tableRef = tableReference;
  },

  pushBrandFilter(state, brand) {
    if (brand.id && state.selectFilters.brand) {
      state.selectFilters.brand.options = state.selectFilters.brand.options.concat({
        label: brand.name,
        value: brand.id,
      });
    }
  },
  resetBrandFilter(state) {
    state.selectFilters.brand = {
      value: get(state, "selectFilterValues.brand", ""),
      options: [],
    };
  },

  addDrawnAppointmentId(state, appointmentIds) {
    state.drawnAppointmentIds.push(appointmentIds);
  },

  addDrawnUnavailabilityId(state, unavailabilityId) {
    state.drawnUnavailabilityIds.push(unavailabilityId);
  },
  resetDrawnUnavailabilityIds(state) {
    state.drawnUnavailabilityIds = [];
  },

  resetAllDrawnIds(state) {
    state.drawnAppointmentIds = [];
    state.drawnUnavailabilityIds = [];
  },

  setHiddenFilter(state, { type, value }) {
    state.hiddenFilters[type] = value;
  },
  setHiddenFilters(state, hiddenFilters) {
    state.hiddenFilters = hiddenFilters;
  },

  startFiltering(state) {
    if (state.lockFilters) {
      return;
    }

    state.shouldFilter = true;
  },
  stopFiltering(state) {
    state.shouldFilter = false;
  },
  toggleFilterLock(state) {
    state.lockFilters = !state.lockFilters;
  },

  updateCurrentDate(state, date) {
    if (state.lockFilters) {
      return;
    }

    state.currentDate = date;
  },
};

const actions = {
  initialise: async ({ state, commit, dispatch }) => {
    state.initialised = false;

    state.currentFilters = {
      brand_id: null,
      postcode: null,
      service_types: [],
    };
    state.hiddenFilters = {
      brand_id: null,
      postcode: null,
      service_types: [],
    };

    // Pull selected filter values from persisted state of tech-availability.selectFilterValues
    // Brand should be done in commit("resetBrandFilter")
    state.selectFilters.type.value = get(state, "selectFilterValues.type", "");

    if (state.selectFilters.state) {
      state.selectFilters.state.value = get(state, "selectFilterValues.state", "");
    }

    commit("resetBrandFilter");
    const brands = await dispatch("brands/getData", null, { root: true });
    brands.map((brand) => {
      commit("pushBrandFilter", brand);
      return brand;
    });

    state.initialised = true;
  },

  reload: ({ state }) => {
    Vue.nextTick(() => state.tableRef.refresh());
  },

  filter: ({ state }) => {
    if (state.lockFilters) {
      return;
    }

    if (state.shouldFilter) {
      if (JSON.stringify(state.hiddenFilters) !== JSON.stringify(state.currentFilters)) {
        TableEvent.$emit("vue-tables.filter::hiddenFilters", state.hiddenFilters);
        state.currentFilters = window.clone(state.hiddenFilters);
      }
    } else {
      if (
        state.currentFilters.brand_id ||
        state.currentFilters.postcode ||
        state.currentFilters.service_types.length > 0
      ) {
        TableEvent.$emit("vue-tables.filter::hiddenFilters", {
          brand_id: null,
          postcode: null,
          service_types: [],
        });
      }

      state.currentFilters = {
        brand_id: null,
        postcode: null,
        service_types: [],
      };
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
